import { jsx } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import useGetSurveyContent from "../../hooks/useGetSurveyContent.js";
import { ChatbotDataContext } from "../../context/ChatbotDataContext.js";
import { Box } from "pcln-design-system";
import { CaresSurvey } from "@pcln/feedback-survey";
import usePostSurveyContent from "../../hooks/usePostSurveyContent.js";
import Loading from "../Loading/index.js";
const PennyCaresSurvey = ({ onClose, offerNumber })=>{
    const { submitChatMessagesPayload } = useContext(ChatbotDataContext);
    const [variables, setVariables] = useState({
        encodedId: '',
        answers: void 0
    });
    const { details, isDetailsRetrieved, encodedId, loading } = useGetSurveyContent(submitChatMessagesPayload);
    const { isAnswersSent } = usePostSurveyContent(variables);
    useEffect(()=>{
        if (isAnswersSent) {
            const offerProcessed = localStorage.getItem('PennyCaresSurveyDict');
            if (offerProcessed && 'string' == typeof offerProcessed) try {
                const parsedOfferProcessed = JSON.parse(offerProcessed);
                parsedOfferProcessed.push(offerNumber);
                localStorage.setItem('PennyCaresSurveyDict', JSON.stringify(parsedOfferProcessed));
            } catch (e) {
                localStorage.setItem('PennyCaresSurveyDict', JSON.stringify([
                    offerNumber
                ]));
            }
            else localStorage.setItem('PennyCaresSurveyDict', JSON.stringify([
                offerNumber
            ]));
        }
    }, [
        isAnswersSent
    ]);
    if (loading) return /*#__PURE__*/ jsx(Loading, {});
    if (!isDetailsRetrieved && !loading) {
        onClose();
        return null;
    }
    const processScoresSubmitted = (scoresSubmitted)=>{
        const answers = [];
        const questionIds = Object.keys(scoresSubmitted);
        questionIds.forEach((id)=>{
            answers.push({
                id,
                answer: {
                    value: scoresSubmitted[id].value,
                    type: 'rating' === scoresSubmitted[id].type ? 'numeric' : 'text'
                }
            });
        });
        return answers;
    };
    async function handleSurveySubmit(scoresSubmitted) {
        const answersForSubmission = processScoresSubmitted(scoresSubmitted);
        setVariables({
            encodedId,
            answers: answersForSubmission
        });
    }
    return /*#__PURE__*/ jsx(Box, {
        p: 4,
        children: /*#__PURE__*/ jsx(CaresSurvey, {
            surveyDetails: details,
            submitFunction: handleSurveySubmit
        })
    });
};
const Survey_PennyCaresSurvey = PennyCaresSurvey;
export { Survey_PennyCaresSurvey as default };
